<template>
	<div id="app">
		<header class="header" @click="hiddenErrorPopup">
			<transition name="menu-fade">
				<div class="menu_button" v-if="menuButtonShow.val" @click="menu">main menu</div>
			</transition>
			<div class="container">
				<button @click="authorize" class="auth" v-if="exit">{{valueButton.val}}</button>
				<div v-else>
					<h3 @click="credentials">{{userName}}
						<span class="small"
						      v-if="getReqUserRole === 'Администратор уровня Бог'">под</span>
						<span class="small2"
						      v-if="getReqUserRole === 'Администратор уровня Бог'">{{getViewUser}}</span>
					</h3>
					<button @click="logout" class="auth">{{valueButton.val}}</button>
				</div>
				<h1>
					<span>Just </span>
					<span>T</span>
					<span>V</span>
				</h1>
			</div>
		</header>
		<preloader v-if="getLoad"/>
		<bg/>
		<router-view name="menu"
		             v-if="menuShow"
		             @hiddenMainMenu="hiddenMenu"/>
		<router-view name="dashboard"
		             v-if="menuButtonShow.val"/>
		<router-view name="parameters"
		             v-if="menuButtonShow.val"/>
		<router-view name="drawtable"
		             v-if="menuButtonShow.val"/>
		<router-view name="playlist"
		             v-if="menuButtonShow.val"/>
		<router-view name="auth"
		             @onmenushow="showMenuButton"
		             :authorize="valueButton.val"
		             :logout="logout"
		             v-if="noError.val"/>
		<error v-else/>
		<too-large-payload v-if="getTooLargePayload"/>
		<empty-payload v-if="getEmptyPayload"/>
		<incorrect-data v-if="getIncorrectData"/>
		<chart-container-day v-if="getChartContainerDay"/>
	</div>
</template>
<script>
	import { mapActions, mapGetters, mapMutations } from "vuex";

	import { performRequest, init } from "./script/ws/wsclient";
	import Error                    from "./components/Error";
	import mainMenu                 from "./components/MainMenu";
	import bg                       from "./components/Bg";
	import Table                    from "./components/Table";
	import Preloader                from "./components/Preloader";
	import ChartContainerDay        from "./components/ChartContainerDay";
	import Playlist                 from "./components/Playlist";
	import CanvasJS                 from "./assets/canvasjs.min";
	import TooLargePayload          from "./components/tooLargePayload";
	import EmptyPayload             from "./components/emptyPayload";
	import IncorrectData            from "./components/incorrectData";

	export default {
		name:       "App",
		components: {
			IncorrectData,
			EmptyPayload,
			TooLargePayload,
			ChartContainerDay,
			Preloader,
			Error,
			mainMenu,
			bg,
			Table,
			Playlist,
		},
		data() {
			return {
				userName:       "",
				valueButton:    { val: "Вход" },
				menuButtonShow: { val: false },
				menuShow:       false,
				commandWS:      {
					section: "authorize",
					name:    "logout",
				},
				Role:           "",
				noError:        { val: true },
			};
		},
		mounted() {
			init(this.$router, this.valueButton, this.noError, this.menuButtonShow);
		},
		methods:    {
			...mapActions([
				"setSelectedMenu",
				"setHiddenParameters",
				"setReqUserRole"
			]),
			...mapMutations([
				"setChartContainerDay",
				"setPrevPath",
				"setChannelist",
				"setThisChannel",
				"setViewUser",
				"setTooLargePayload",
				"setEmptyPayload",
				"setIncorrectData"
			]),
			hiddenErrorPopup() {
				this.setTooLargePayload(false);
				this.setEmptyPayload(false);
				this.setIncorrectData(false)
			},
			showMenuButton(payload) {
				this.menuButtonShow.val = payload.menuShow;
				this.valueButton.val    = `${payload.buttonExit}`;
				this.userName           = payload.user;
			},
			authorize() {
				this.noError.val
					? this.$router.push("/auth")
					: this.$router.push("/");
			},
			menu() {
				this.menuShow = !this.menuShow;
				this.setChartContainerDay(false);
				if (this.menuShow) {
					this.setHiddenParameters(true);
				}
			},
			logout() {
				performRequest(this.commandWS, null, () => {
					this.menuButtonShow.val = false;
					this.valueButton.val    = "Вход";
					this.setSelectedMenu("");
				});
				this.setReqUserRole("");
				this.setChartContainerDay(false);
				this.setChannelist([{
					archive_limit: "",
					display_name:  "",
					name:          "",
					poster_url:    "",
					is_censored:   "",
					is_federal:    "",
					epg_api_id:    "",
					epg_jtv:       "",
					is_free:       "",
					is_ottfree:    "",
					operator:      ""
				}]);
				this.setThisChannel({});
				this.setViewUser("");
				this.$router.push("/");
			},
			hiddenMenu(payload) {
				this.menuShow = payload.menuShow;
			},
			credentials() {
				document.documentElement.scrollTop = 0;
				this.setPrevPath(this.$route.path);
				if (this.$router.history.current.path === "/auth") {
					this.$router.push("/menu/dashboard");
					this.setSelectedMenu("0");
				} else {
					this.$router.push("/auth");
					this.setChartContainerDay(false);
				}
			},
		},
		computed:   {
			...mapGetters([
				"getLoad",
				"getChartContainerDay",
				"getViewUser",
				"getReqUserRole",
				"getEmptyPayload",
				"getTooLargePayload",
				"getIncorrectData"
			]),
			exit() {
				if (this.valueButton.val === "Вход") {
					this.menuShow = false;
					this.setSelectedMenu("");
					return true;
				} else {
					this.menuShow = false;
					return false;
				}
			},
		},
	};
</script>
<style lang="stylus">
	@import './style/reboot.css';
	@import './style/style.styl';
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
	}
	.small {
		font-size: .7rem
	}
	.small2 {
		font-size: .9rem
	}
	.menu-fade-enter-active {
		transition: all 0.5s ease;
	}
	.menu-fade-leave-active {
		transition: all 0.5s ease;
	}
	.menu-fade-enter, .menu-fade-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue